import {FC} from 'react'

import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const UserWithCheckmarkIcon: FC<IconProps> = ({
  color = theme.palette.text.default,
  size,
}) => (
  <Icon size={size}>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="10.5003"
        cy="6.24841"
        r="4.25177"
        stroke={color}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.49707 18.0033C2.49707 15.5172 4.51291 13.5014 6.99895 13.5014H9.58302"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={color}
      />
      <path
        d="M17.5031 14.9401L14.5019 17.9413L12.7021 16.1406"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={color}
      />
    </svg>
  </Icon>
)
